import React from 'react';
import landingCircleBottomLeft from "./assets/landing-1-circle-bottom-left.svg";
import landingCircleTopLeft from "./assets/landing-1-circle-top-left.svg";
import landingCirclePurple from "./assets/landing-1-circle-purple.svg";
import landingCircleGreen from "./assets/landing-1-circle-green.svg";
import landingCircleBottomRight from "./assets/landing-1-circle-bottom-right.svg";
import appImage from "./assets/landing-app.png";
import {FormattedMessage} from "react-intl";
import Footer from "../components/footer";

const Landing = () => {

  return (
    <div className="landing">
      <div className="container-fluid landing__first">
        <img className="landing__first-circle-bottom-left" src={landingCircleBottomLeft} alt=""/>
        <img className="landing__first-circle-top-left" src={landingCircleTopLeft} alt=""/>
        <img className="landing__first-circle-purple" src={landingCirclePurple} alt=""/>
        <img className="landing__first-circle-green" src={landingCircleGreen} alt=""/>
        <img className="landing__first-circle-bottom-right" src={landingCircleBottomRight} alt=""/>
        <img className="landing__first-app" src={appImage} alt=""/>

        <div className="row">
          <div className="col-12">
            <div className="landing__first-content">
              <h1 className="landing__first-content-title">
                <FormattedMessage id={'landing.first.title'} values={{
                  firstHashtag: (
                    <a target="_blank" rel="noopener noreferrer"
                       href="https://www.instagram.com/explore/tags/toetankohalikku/"
                       className="landing__first-content-title-hashtag">
                      #toetankohalikku
                    </a>
                  ),
                  secondHashtag: (
                    <a target="_blank" rel="noopener noreferrer"
                       href="https://www.instagram.com/explore/tags/eestitoit/"
                       className="landing__first-content-title-hashtag">
                      #eestitoit
                    </a>
                  ),
                }}/>
              </h1>
              <p className="landing__first-content-description m-b-6">
                <FormattedMessage id={'landing.first.description'}/>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer/>

    </div>
  );
};

Landing.propTypes = {};

Landing.defaultProps = {};

export default Landing;
